// import React, { Fragment } from 'react';
// import { connect } from 'react-redux';
// import * as actions from '../actions';
// import Button from '@mui/material/Button';
// import logo from '../assets/images/logo.png';
// import '../css/LoginForm.css';

// class SetNewPasswordForm extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       newpassword: '',
//       confirmpassword: '',
//       invalidCredentials: false,
//       sessionTimeout: false,
//       errors: {},
//          browserDetails: {},
//     };
//   }

//   componentDidMount() {
//     const tokenStored = localStorage.getItem('token');
//     if (tokenStored !== null) {
//       window.location.href = '/dashboard';
//     }

//     if (window.location.pathname === '/session-timeout') {
//       this.setState({ sessionTimeout: true }, () => {
//         setTimeout(() => this.setState({ sessionTimeout: false }), 5000);
//       });
//     }
//   }

// validate = () => {
//   const errors = {};
//   const { newpassword, confirmpassword } = this.state;

//   const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

//   // New password validation
//   if (!newpassword) {
//     errors.newpassword = 'New password is required';
//   } else if (!passwordRegex.test(newpassword)) {
//     errors.newpassword =
//       'Password must be at least 8 characters long and include an uppercase letter, number, and special character';
//   }

//   // Confirm password validation
//   if (!confirmpassword) {
//     errors.confirmpassword = 'Confirm password is required';
//   } else if (newpassword !== confirmpassword) {
//     errors.confirmpassword = 'Passwords must match';
//   }

//   return errors;
// };


//   onSubmit = (e) => {
//     e.preventDefault();

//     const errors = this.validate();
//     if (Object.keys(errors).length > 0) {
//       this.setState({ errors });
//       return;
//     }

//     this.setState({ errors: {} });

//     const formProps = {
//     //   newpassword: this.state.newpassword,
//       confirmpassword: this.state.confirmpassword,
//     };

//     this.props.setPassword(formProps, (result) => {
//       if (result !== 'invalidLogin') {
//         // Redirect to login page after successful password set
//         window.location.href = '/';
//       } else {
//         this.setState({ invalidCredentials: true }, () => {
//           setTimeout(() => this.setState({ invalidCredentials: false }), 3000);
//         });
//       }
//     });
//   };

//   render() {
//     const {
//       newpassword,
//       confirmpassword,
//       invalidCredentials,
//       sessionTimeout,
//       errors,
//     } = this.state;

//     return (
//       <Fragment>
//         <div className="loginForm" style={{ backgroundColor: 'white' }}>
//           <div className="loginUnder">
//             <form onSubmit={this.onSubmit} noValidate>
//               <img src={logo} style={{ width: '100%' }} alt="Logo" />
//               <div className="text-muted my-2 text-center">
//                 Welcome! Please set new password
//               </div>

//               {invalidCredentials && (
//                 <div className="alert alert-danger text-center" role="alert">
//                   Invalid credentials
//                 </div>
//               )}
//               {sessionTimeout && (
//                 <div className="alert alert-danger text-center" role="alert">
//                   Session Timeout
//                 </div>
//               )}

//               <div className="group">
//                 <input
//                   type="password"
//                   name="newpassword"
//                   value={newpassword}
//                   onChange={(e) => this.setState({ newpassword: e.target.value })}
//                   style={{ backgroundColor: 'transparent' }}
//                   required
//                   autoComplete="new-password"
//                 />
//                 <span className="highlight"></span>
//                 <span className="bar"></span>
//                 <label>New Password</label>
//                 {errors.newpassword && (
//                   <div style={{ color: 'red', fontSize: '0.8rem' }}>
//                     {errors.newpassword}
//                   </div>
//                 )}
//               </div>

//               <div className="group">
//                 <input
//                   type="password"
//                   name="confirmpassword"
//                   value={confirmpassword}
//                   onChange={(e) => this.setState({ confirmpassword: e.target.value })}
//                   style={{ backgroundColor: 'transparent' }}
//                   required
//                   autoComplete="new-password"
//                 />
//                 <span className="highlight"></span>
//                 <span className="bar"></span>
//                 <label>Confirm Password</label>
//                 {errors.confirmpassword && (
//                   <div style={{ color: 'red', fontSize: '0.8rem' }}>
//                     {errors.confirmpassword}
//                   </div>
//                 )}
//               </div>

//               <div className="mt-5 btn btn-block">
//                 <Button
//                   className="myButton"
//                   type="submit"
//                   fullWidth
//                   style={{ backgroundColor: '#00b0a9', color: 'white' }}
//                 >
//                   Activate Account
//                 </Button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </Fragment>
//     );
//   }
// }

// export default connect(null, actions)(SetNewPasswordForm);

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Button from '@mui/material/Button';
import logo from '../assets/images/logo.png';
import '../css/LoginForm.css';

class SetNewPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newpassword: '',
      confirmpassword: '',
      invalidCredentials: false,
      sessionTimeout: false,
      errors: {},
      browserDetails: {},
    };
  }

  componentDidMount() {
    const tokenStored = localStorage.getItem('token');
    if (tokenStored !== null) {
      window.location.href = '/dashboard';
    }

    if (window.location.pathname === '/session-timeout') {
      this.setState({ sessionTimeout: true }, () => {
        setTimeout(() => this.setState({ sessionTimeout: false }), 5000);
      });
    }

    this.browserDediction(); // Auto-fetch browser info
  }

  osDediction = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

    if (macosPlatforms.includes(platform)) return 'Mac OS';
    if (iosPlatforms.includes(platform)) return 'iOS';
    if (windowsPlatforms.includes(platform)) return 'Windows';
    if (/Android/.test(userAgent)) return 'Android';
    if (/Linux/.test(platform)) return 'Linux';
    return 'Unknown OS';
  };

  browserDediction = () => {
    let objAgent = navigator.userAgent;
    let objbrowserName = navigator.appName;
    let objfullVersion = '' + parseFloat(navigator.appVersion);
    let objBrMajorVersion = parseInt(navigator.appVersion, 10);
    let objOffsetVersion, objOffsetName, ix;

    if ((objOffsetVersion = objAgent.indexOf("Chrome")) !== -1) {
      objbrowserName = "Chrome";
      objfullVersion = objAgent.substring(objOffsetVersion + 7);
    } else if ((objOffsetVersion = objAgent.indexOf("MSIE")) !== -1) {
      objbrowserName = "Microsoft Internet Explorer";
      objfullVersion = objAgent.substring(objOffsetVersion + 5);
    } else if ((objOffsetVersion = objAgent.indexOf("Firefox")) !== -1) {
      objbrowserName = "Firefox";
    } else if ((objOffsetVersion = objAgent.indexOf("Safari")) !== -1) {
      objbrowserName = "Safari";
      objfullVersion = objAgent.substring(objOffsetVersion + 7);
      if ((objOffsetVersion = objAgent.indexOf("Version")) !== -1) {
        objfullVersion = objAgent.substring(objOffsetVersion + 8);
      }
    } else if ((objOffsetName = objAgent.lastIndexOf(' ') + 1) < (objOffsetVersion = objAgent.lastIndexOf('/'))) {
      objbrowserName = objAgent.substring(objOffsetName, objOffsetVersion);
      objfullVersion = objAgent.substring(objOffsetVersion + 1);
      if (objbrowserName.toLowerCase() === objbrowserName.toUpperCase()) {
        objbrowserName = navigator.appName;
      }
    }

    if ((ix = objfullVersion.indexOf(";")) !== -1) {
      objfullVersion = objfullVersion.substring(0, ix);
    }
    if ((ix = objfullVersion.indexOf(" ")) !== -1) {
      objfullVersion = objfullVersion.substring(0, ix);
      objBrMajorVersion = parseInt(objfullVersion, 10);
    }
    if (isNaN(objBrMajorVersion)) {
      objfullVersion = '' + parseFloat(navigator.appVersion);
      objBrMajorVersion = parseInt(navigator.appVersion, 10);
    }

    const details = {
      browserName: objbrowserName,
      fullVersion: objfullVersion,
      majorVersion: objBrMajorVersion,
      appName: navigator.appName,
      userAgent: navigator.userAgent,
      os: this.osDediction(),
      date: {
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString()
      }
    };

    this.setState({ browserDetails: details });
  };

  validate = () => {
    const errors = {};
    const { newpassword, confirmpassword } = this.state;

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!newpassword) {
      errors.newpassword = 'New password is required';
    } else if (!passwordRegex.test(newpassword)) {
      errors.newpassword = 'Password must be at least 8 characters long and include an uppercase letter, number, and special character';
    }

    if (!confirmpassword) {
      errors.confirmpassword = 'Confirm password is required';
    } else if (newpassword !== confirmpassword) {
      errors.confirmpassword = 'Passwords must match';
    }

    return errors;
  };

  onSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ errors: {} });

    const { browserDetails } = this.state;

   // console.log(browserDetails);

    const formProps = {
      confirmpassword: this.state.confirmpassword,
      browserDetails: {
        ...browserDetails,
        // locationApi: this.props.locationApi || null,
        // browserLocation: this.props.browserLocation || null
      }
    };

    this.props.setPassword(formProps, (result) => {
      if (result !== 'invalidLogin') {
        window.location.href = '/';
      } else {
        this.setState({ invalidCredentials: true }, () => {
          setTimeout(() => this.setState({ invalidCredentials: false }), 3000);
        });
      }
    });
  };

  render() {
    const {
      newpassword,
      confirmpassword,
      invalidCredentials,
      sessionTimeout,
      errors,
    } = this.state;

    return (
      <Fragment>
        <div className="loginForm" style={{ backgroundColor: 'white' }}>
          <div className="loginUnder">
            <form onSubmit={this.onSubmit} noValidate>
              <img src={logo} style={{ width: '100%' }} alt="Logo" />
              <div className="text-muted my-2 text-center">
                Welcome! Please set new password
              </div>

              {invalidCredentials && (
                <div className="alert alert-danger text-center" role="alert">
                  Invalid credentials
                </div>
              )}
              {sessionTimeout && (
                <div className="alert alert-danger text-center" role="alert">
                  Session Timeout
                </div>
              )}

              <div className="group">
                <input
                  type="password"
                  name="newpassword"
                  value={newpassword}
                  onChange={(e) => this.setState({ newpassword: e.target.value })}
                  style={{ backgroundColor: 'transparent' }}
                  required
                  autoComplete="new-password"
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>New Password</label>
                {errors.newpassword && (
                  <div style={{ color: 'red', fontSize: '0.8rem' }}>
                    {errors.newpassword}
                  </div>
                )}
              </div>

              <div className="group">
                <input
                  type="password"
                  name="confirmpassword"
                  value={confirmpassword}
                  onChange={(e) => this.setState({ confirmpassword: e.target.value })}
                  style={{ backgroundColor: 'transparent' }}
                  required
                  autoComplete="new-password"
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Confirm Password</label>
                {errors.confirmpassword && (
                  <div style={{ color: 'red', fontSize: '0.8rem' }}>
                    {errors.confirmpassword}
                  </div>
                )}
              </div>

              <div className="mt-5 btn btn-block">
                <Button
                  className="myButton"
                  type="submit"
                  fullWidth
                  style={{ backgroundColor: '#00b0a9', color: 'white' }}
                >
                  Activate Account
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(null, actions)(SetNewPasswordForm);


